import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsWorkloadRoute: InvariantJiraRoute = {
	name: 'csm-reports-workload',
	path: '/jira/customer-service-management/projects/:projectKey/reports/workload',
	exact: true,
};
